import React, {
	memo
}from 'react'
import {
	useSelector
}from 'react-redux'
import {
	Skeleton, Tooltip
}from 'antd'
import i18n from './localization'
import SignedIcon from "../../../../public/signedIcon.png"

const AnswerFiles = memo(({
	isRu, answerFiles, showSignerInfo, downloadMethod
}) => {

	return (
		<>
			{ answerFiles !== null ? (
				answerFiles.length ? (
					<>
						<span>
							{ i18n.answerFiles[isRu] }
						</span>
						<div>
							{ answerFiles.map((item) => {
								return (
									<div
										key={ `appealAnswerFile_${ item.id }` }
										className="custom-file"
									>
										{item.signerInfo && showSignerInfo &&
											<Tooltip 
												title={i18n.signer[isRu].format(item.signerInfo)}
												overlayInnerStyle={{ whiteSpace: 'pre-line' }}
												className='signed_icon'
											>
												<img src={SignedIcon}/>
											</Tooltip>
										}
										<Tooltip
											placement="left"
											title={`${item.fileName}${item.fileExtension}`}
										>
											<a onClick={ () => downloadMethod(item) }>
												{ item.fileName + item.fileExtension }
											</a>
										</Tooltip>
									</div>
								)
							}) }
						</div>
					</>
				) : null
			) : (
				<Skeleton
					active
					loading
				/>
			) }
		</>
	)
})

export default AnswerFiles